<template>
    <div class="animated fadeIn">
        <b-row class="my-3">
            <b-col>
                <h4 class="text-center text-primary">
                    <i class="fa fa-bar-chart text-primary mr-2"></i>
                   Búsquedas Contable
                </h4>
            </b-col>
        </b-row>

        <b-row>
            <b-col>
                <b-card>
                    <b-row>
                        <b-col col>
                            <b-row>
                                <b-col cols="auto">
                                    <b-form-group
                                        label="<strong>Predeterminados</strong>"
                                        label-cols="2"
                                        :horizontal="false">
                                        <div>
                                            <button class="btn btn-primary btn-sm" @click="setUpDates(2)">
                                                Últimos 3 Meses
                                            </button>

                                            <button class="btn btn-primary btn-sm ml-2" @click="setUpDates(5)">
                                                Últimos 6 Meses
                                            </button>

                                            <button class="btn btn-primary btn-sm ml-2" @click="setUpDates(11)">
                                                Último Año
                                            </button>
                                        </div>
                                    </b-form-group>
                                </b-col>
                            </b-row>

                            <b-row class="mt-2">
                                <b-col cols="6">
                                    <b-form-group label="<strong>Desde</strong>">
                                        <month-and-year-selector v-model="dates.start"></month-and-year-selector>
                                    </b-form-group>
                                </b-col>

                                <b-col cols="6">
                                    <b-form-group label="<strong>Hasta</strong>">
                                        <month-and-year-selector v-model="dates.end"></month-and-year-selector>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                        </b-col>

                        <b-col cols="auto" align-self="start">
                            <div>
                                <button
                                    :disabled="!dates.start || !dates.end"
                                    class="btn btn-pill btn-primary px-4"
                                    @click="loadAccountingTable">
                                    Buscar
                                </button>
                            </div>
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
        </b-row>

        <b-row v-if="loading">
            <b-col>
                <b-card>
                    <spinner line-fg-color="#025542" line-bg-color="#c8ced3" size="100" line-size="12" spacing="20" font-size="20" message="Calculando. Por favor espere, este proceso puede tardar unos minutos."></spinner>
                </b-card>
            </b-col>
        </b-row>

        <b-row v-if="accountingTable.headquarters.length" class="animated fadeIn">
            <b-col>
                <b-card>
                    <div class="accounting-table-container">
                        <table class="accounting-table">
                            <thead>
                            <tr>
                                <th rowspan="2" class="header text-center">
                                    SEDE
                                </th>

                                <th rowspan="2" class="header text-center">
                                    CUOTA
                                </th>

                                <th
                                    v-for="(range, index) in ranges"
                                    :key="index"
                                    colspan="4"
                                    :class="[range.isTotal ? 'total' : 'header']"
                                    class="text-center">
                                    <template v-if="range.isTotal">
                                        TOTAL
                                    </template>
                                    <template v-else>
                                        {{(range.start.toLocaleDateString('default', {year: 'numeric', month: 'long'})).toLocaleUpperCase()}}
                                    </template>
                                </th>
                            </tr>

                            <tr>
                                <template v-for="(range, index) in ranges">
                                    <th :class="[range.isTotal ? 'total' : 'header', 'text-center']">
                                        Importe
                                    </th>

                                    <th :class="[range.isTotal ? 'total' : 'header', 'text-center']">
                                        Enviado
                                    </th>

                                    <th :class="[range.isTotal ? 'total' : 'header', 'text-center']">
                                        Devuelto
                                    </th>

                                    <th :class="[range.isTotal ? 'total' : 'header', 'text-center']">
                                        Condonado
                                    </th>
                                </template>
                            </tr>
                            </thead>

                            <tbody>
                            <template v-for="(headquarter, headquarterIndex) in accountingTable.headquarters">
                                <template v-for="(fee, feeIndex) in headquarter.fees">
                                    <tr :class="[headquarter.is_total ? 'total' : (headquarterIndex % 2 ? 'pair' : 'odd')]">
                                        <template v-if="headquarter.code === fee.name">
                                            <td :rowspan="headquarter.fees.length" colspan="2" class="text-center">
                                                <b>{{headquarter.code}}</b>
                                            </td>
                                        </template>

                                        <template v-else>
                                            <td
                                                v-if="feeIndex === 0"
                                                :rowspan="headquarter.fees.length"
                                                class="text-center">
                                                <b>{{headquarter.code}}</b>
                                            </td>

                                            <td>
                                                <b>
                                                    <template v-if="fee.is_total">{{fee.name}}</template>
                                                    <periodicity-name
                                                        v-else
                                                        :value="fee.name"
                                                        :upper-case="true"></periodicity-name>
                                                </b>
                                            </td>
                                        </template>

                                        <template v-for="(range, rangeIndex) in fee.ranges">
                                            <td
                                                :class="[headquarter.is_total ? 'total' : (range.is_total ? 'subtotal' : '')]"
                                                class="text-right">
                                                <b v-if="fee.is_total">
                                                    {{roundNumber(range.statistics.expected)}}
                                                </b>
                                                <template v-else>
                                                    {{roundNumber(range.statistics.expected)}}
                                                </template>
                                            </td>

                                            <td
                                                :class="[headquarter.is_total ? 'total' : (range.is_total ? 'subtotal' : '')]"
                                                class="text-right">
                                                <b v-if="fee.is_total">
                                                    {{roundNumber(range.statistics.posted)}}
                                                </b>
                                                <template v-else>
                                                    {{roundNumber(range.statistics.posted)}}
                                                </template>
                                            </td>

                                            <td
                                                :class="[headquarter.is_total ? 'total' : (range.is_total ? 'subtotal' : '')]"
                                                class="text-right">
                                                <b v-if="fee.is_total">
                                                    {{roundNumber(range.statistics.returned)}}
                                                </b>
                                                <template v-else>
                                                    {{roundNumber(range.statistics.returned)}}
                                                </template>
                                            </td>

                                            <td
                                                :class="[headquarter.is_total ? 'total' : (range.is_total ? 'subtotal' : '')]"
                                                class="text-right">
                                                <b v-if="fee.is_total">
                                                    {{roundNumber(range.statistics.canceled)}}
                                                </b>
                                                <template v-else>
                                                    {{roundNumber(range.statistics.canceled)}}
                                                </template>
                                            </td>
                                        </template>
                                    </tr>
                                </template>
                            </template>
                            </tbody>
                        </table>
                    </div>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    import {getAccountingTable} from '@/api/statistics-api';
    import periodicityName from '@/components/periodicity/PeriodicityName';
    import monthAndYearSelector from '@/components/MonthAndYearSelector';
    import Spinner from 'vue-simple-spinner';
    import moment from 'moment'

    export default {
        name: "SearchTable",
        components: {
            periodicityName,
            monthAndYearSelector,
            Spinner
        },
        data() {
            return {
                topMenu: [
                    {
                        name: 'Remesas',
                        path: '/accounting/consignments/list',
                        brand: 'fa fa-industry'
                    }
                ],
                accountingTable: {
                    headquarters: []
                },
                ranges: [],
                dates: {
                    start: null,
                    end: null
                },
                filters: {
                    start: null,
                    numberOfRanges: null,
                    monthsPerRange: 1
                },
                loading: false
            }
        },
        created() {
            this.$eventHub.$emit('captureMenu', this.topMenu);
            this.setUpDates(2);
        },
        methods: {
            setUpDates(monthsDifference) {
                this.dates.start = moment().subtract(monthsDifference, 'months').startOf('months').toDate();
                this.dates.end = moment().subtract(1, 'months').endOf('months').toDate();
            },
            async loadAccountingTable() {
                this.$_loadingMixin_showLoading();
                this.loading = true;
                this.setUpFilters();
                await getAccountingTable(this.filters.start, this.filters.numberOfRanges, this.filters.monthsPerRange)
                    .then((accountingTable) => {
                        this.accountingTable = accountingTable;
                        this.setUpRanges();
                    });
                this.$_loadingMixin_hideLoading();
                this.loading = false;
            },
            setUpFilters() {
                this.filters.start = moment(this.dates.start).format();
                this.filters.numberOfRanges = this.dates.start < this.dates.end
                    ? this.getFullMonthsDifference(this.dates.start, this.dates.end) + 2
                    : 1;
            },
            getFullMonthsDifference(start, end) {
                let months;
                months = (end.getFullYear() - start.getFullYear()) * 12;
                months -= start.getMonth() + 1;
                months += end.getMonth();
                return months <= 0 ? 0 : months;
            },
            roundNumber(number) {
                return Math.round(number * 100) / 100
            },
            setUpRanges() {
                if (
                    this.accountingTable.headquarters.length
                    && this.accountingTable.headquarters[0].fees.length
                    && this.accountingTable.headquarters[0].fees[0].ranges.length
                ) {
                    this.ranges = [];
                    this.accountingTable.headquarters[0].fees[0].ranges.forEach(range => {
                        this.addRange(range);
                    });
                }
            },
            addRange(range) {
                this.ranges.push({
                    start: new Date(range.start),
                    end: new Date(range.end),
                    isTotal: range.is_total
                });
            },
            checkDatesDifference() {
                if (
                    !!this.dates.start
                    && !!this.dates.end
                    && this.getFullMonthsDifference(this.dates.start, this.dates.end) > 10
                ) {
                    this.$_notificationMixin_error('Rango Inválido', 'La diferencia entre fechas no puede exceder 1 año');
                    this.setUpDates(2);
                }
            }
        },
        watch: {
            'dates.start': function () {
                this.checkDatesDifference();
                if (this.dates.start > this.dates.end) {
                    this.dates.end = this.dates.start;
                }
            },
            'dates.end': function () {
                this.checkDatesDifference();
                if (this.dates.end < this.dates.start) {
                    this.dates.start = this.dates.end;
                }
            }
        }
    }
</script>

<style lang="scss">
    .header {
        background-color: #03A17C;
    }

    .total {
        background-color: goldenrod;
    }

    .subtotal {
        background-color: lightgoldenrodyellow;
    }

    .pair {
        background-color: #63e2c6;
    }

    .odd {
        background-color: white;
    }

    .pair .subtotal {
        background-color: rgb(254, 229, 157);
    }

    .accounting-table-container {
        overflow: scroll;
        height: 550px;
    }

    table.accounting-table {
        border-collapse: collapse;
        border: 1px solid black;

        th, td {
            border: 1px solid black;
            padding: 0.25rem;
        }
    }
</style>
